import { useEffect, useState } from 'react';
import { Card } from '../../../../components/layout/card/Card';
import { useNavigate } from 'react-router';
import SourceApiRepository from '../../../../repositories/api/SourceApiRepository'
import { isAspiringPilotAndNotProcessedToPilotAssignment } from '../../pilot-assignment/helpers/PilotAssignmentHelpers';
import PilotAssignmentIdbRepository from '../../../../repositories/idb/PilotAssignmentIdbRepository';
import PilotageApiRepository from '../../../../repositories/api/PilotageApiRepository';
import { Checkbox } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import Spacer from 'components/layout/Spacer';
import { useSuccessNotification, useWarningNotification } from 'components/hooks/useAppStore';

interface SelfAssignCardProps {
    pilotageId: number;
    handleAssignmentStatus: any;
    pilotagePilotsInformation: any;
}

interface PilotStatusProps {
    nameNor: string;
    systemName: string;
    value: number;
}

export const SelfAssignCard = ({ pilotageId, handleAssignmentStatus, pilotagePilotsInformation }: SelfAssignCardProps) => {
    const navigate = useNavigate();

    const [pilotData, setPilotData] = useState<{ whoAmI: any } | null>(null);
    const [data, setData] = useState<any>(null);
    const [isBusy, setIsBusy] = useState(false);
    const [confirmedWithShipAndPilotage, setConfirmedWithShipAndPilotage] = useState(false);
    const [hasConfirmedAspiringPilot, setHasConfirmedAspiringPilot] = useState(false);

    const addSuccessNotification = useSuccessNotification();
    const addWarningNotification = useWarningNotification();

    useEffect(() => {
        const getWhoAmI = async () => {
            const response = await SourceApiRepository.getWhoAmIAsync();
            const result = response instanceof Response ? await response.json() : response;
            setPilotData(() => ({
                whoAmI: result
            }));
        }

        const getPilotagePilot = async () => {
            const result = await PilotAssignmentIdbRepository.getByPilotageIdAsync(pilotageId);
            setData(() => ({
                pilotagePilot: result
            }));
        }

        getWhoAmI();
        getPilotagePilot();
    }, [pilotageId, handleAssignmentStatus]);

    useEffect(() => {
        var confirmedAspiringPilot = pilotagePilotsInformation.some((pilot: {
            isApprentice: boolean;
            pilotagePilotStatus: { systemName: string }
        }) => pilot.isTrainee)

        setHasConfirmedAspiringPilot(confirmedAspiringPilot);
    }, [pilotagePilotsInformation]);

    const handleConfirmSelfAssign = async () => {
        setIsBusy(true);
        var response = await PilotageApiRepository.confirmSelfAssignedPilotageAsync(data.pilotagePilot.pilotagePilotId, pilotageId);
        var pilotStatus = {
            nameNor: 'Bekreftet',
            systemName: "CONFIRMED",
            value: 0
        };
        
        let responseWithStatus: Response | { ok: boolean; status: number; } =
            response instanceof Response
                ? response
                : { ...response, status: typeof response.status === 'number' ? response.status : -1 };

        handleResponse(responseWithStatus, pilotStatus);
        if (responseWithStatus.status === 404)
            navigate(`/pilot/pilotages/ASSIGNED`);
    };

    const handleResponse = async (response: Response | { ok: boolean; status: number; }, pilotStatus: PilotStatusProps) => {
        if (response.ok === true) {
            addSuccessNotification(`Besvarelsen din ble lagret`);
            handleAssignmentStatus(pilotStatus);
        } else {
            const message = response instanceof Response ? await response.text() : "En ukjent feil oppsto.";
            addWarningNotification(message, "", true);
        }
        setIsBusy(false);
    }

    const handleRemoveSelfAssign = async () => {
        setIsBusy(true);
        var response = await PilotageApiRepository.removeSelfAssignedPilotageAsync(data.pilotagePilot.pilotagePilotId);
        if (response.ok) {
            navigate(`/pilotages/current`);
            addSuccessNotification(`Du har fjernet deg selv fra oppdraget.`);
        }
        setIsBusy(false);
    };

    return (
        <>
            {pilotData && data && isAspiringPilotAndNotProcessedToPilotAssignment(pilotData?.whoAmI, data.pilotagePilot) && (
                <Card
                    title={'Tildel aspirantopplæring'}>
                    {hasConfirmedAspiringPilot ? (
                        <div>
                            <p>Kan ikke selv tildele flere aspiranter på oppdraget.</p>
                            <Spacer />
                            <Spacer />
                            <Button
                                themeColor="error"
                                onClick={() => {
                                    handleRemoveSelfAssign();
                                }}>
                                Fjern
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <Checkbox
                                label=" Deltakelse er avklart med både fartøyet og ansvarlig los."
                                checked={confirmedWithShipAndPilotage}
                                onChange={(e) => setConfirmedWithShipAndPilotage(e.value)}
                            />
                            <Spacer />
                            <Spacer />
                            <Button
                                themeColor="primary"
                                disabled={
                                    !confirmedWithShipAndPilotage ||
                                    hasConfirmedAspiringPilot
                                }
                                onClick={() => {
                                    handleConfirmSelfAssign();
                                }}>
                                Bekreft
                            </Button>
                            <Button
                                themeColor="error"
                                style={{ marginLeft: 8 }}
                                onClick={() => {
                                    handleRemoveSelfAssign();
                                }}>
                                Fjern
                            </Button>
                        </div>
                    )}
                </Card>
            )}
        </>
    );
};
